import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Link, Typography} from 'views/components';
import {
  StickyNote2 as CarePlanIcon,
  CalendarMonth as CalendarIcon,
  ContactPage as CaregiversIcon,
  Apps as AppsIcon,
} from 'views/icons';
import {Translate} from 'views/module';

const NavbarService = (props) => {
  const [mouseOver, setMouseOver] = React.useState(false);
  const [onClick, setOnClick] = React.useState(false);

  const title = props.title;
  const link = props.link;
  const selected = props.selected;

  const hoverDetails = mouseOver && !onClick;

  const getIcon = () => {
    const iconColor = selected ? 'navbar.contrastText' : hoverDetails ? 'navbar.contrastText' : 'navbar.text';

    switch (title.toLowerCase()) {
      case 'navbar.tree.dashboard.title':
        return <CarePlanIcon sx={{mr: 1, fontSize: '1.5rem', color: iconColor}} />;
      case 'navbar.tree.schedule.title':
        return <CalendarIcon sx={{mr: 1, fontSize: '1.5rem', color: iconColor}} />;
      case 'navbar.tree.caregivers.title':
        return <CaregiversIcon sx={{mr: 1, fontSize: '1.5rem', color: iconColor}} />;
      default:
        return <AppsIcon sx={{mr: 1.5, fontSize: '1.5rem', color: iconColor}} />;
    }
  };

  let sx = {};
  let boxSx = {};

  if (selected) {
    boxSx = {
    };
    sx = {
      color: 'navbar.contrastText',
    };
  } else if (hoverDetails) {
    boxSx = {
    };
    sx = {
      color: 'navbar.contrastText',
    };
  } else {
    sx = {
      color: 'navbar.text',
    };
  }

  return (
    <Box
      onMouseEnter={() => setMouseOver(true) & setOnClick(false)}
      onMouseLeave={() => setMouseOver(false)}
      onClick={() => setOnClick(true)}
      sx={{
        py: 1,
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        ...boxSx,
      }}
    >
      <Link
        href={link}
        sx={{
          textDecorationLine: 'none',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 500,
          fontStyle: 'normal',
          fontSize: '1.0rem',
          lineHeight: '150%',
          letterSpacing: 0,
          textTransform: 'capitalize',
          transition: 'all 0.2s ease',
          ...sx,
        }}
      >
        {getIcon()}
        <Typography
          sx={{
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: '1.0rem',
            lineHeight: '150%',
            letterSpacing: 0,
            textTransform: 'capitalize',
          }}
        >
          <Translate expression={title} />
        </Typography>
      </Link>
    </Box>
  );
};
NavbarService.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.bool,
  icon: PropTypes.string,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarService));
